import { useIsLoggedInWithLoading } from '@dreamstack/auth'
import { HousingCostReportOrderReportForm } from '@dreamstack/feature-components/src/housingCostReport/HousingCostOrderReportForm'
import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { useTranslation } from '@dreamstack/i18n'
import { generateIdForText } from '@dreamstack/util'
import Skeleton from '@mui/material/Skeleton'
import type { FunctionComponent } from 'react'
import {
  FormContainer,
  StyledBodyText,
  StyledHeadingH2,
  TextContainer,
} from './CommonStyledComponents/AccessFileStyledComponents'

export const HousingCostReportOrderForm: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const t = useTranslation()
  const { loading, isLoggedIn } = useIsLoggedInWithLoading()
  const headingValue1 = t('accentro:housingCostReportForm.heading1')
  const headingValue2 = t('accentro:housingCostReportForm.heading2')
  return (
    <GridWithGaps>
      <StyledHeadingH2
        id={generateIdForText(headingValue1)}
        className="col-span-full mb-px-24 md:mb-px-48"
      >
        {headingValue1}
      </StyledHeadingH2>
      <StyledHeadingH2
        id={generateIdForText(headingValue2)}
        className="col-span-full mb-px-24 md:mb-px-48"
      >
        {headingValue2}
      </StyledHeadingH2>
      <TextContainer>
        <StyledBodyText className="whitespace-pre-line">
          {t('accentro:housingCostReportForm.bodyText')}
        </StyledBodyText>
      </TextContainer>
      <FormContainer>
        {loading ? (
          <div className="flex flex-col justify-start">
            {Array.from({ length: 3 }).map((_, i) => (
              <Skeleton key={i} className="w-full" height={96} />
            ))}
          </div>
        ) : (
          <HousingCostReportOrderReportForm />
        )}
      </FormContainer>
    </GridWithGaps>
  )
}
